import { Helmet } from 'react-helmet-async';
// sections
import { ManageAccountView } from 'src/sections/account/view';

// ----------------------------------------------------------------------

export default function ManageAccount() {
  return (
    <>
      <Helmet>
        <title> Hireintel - Manage Account</title>
      </Helmet>

      <ManageAccountView />
    </>
  );
}
